<style lang="scss" src="./style.scss" scoped></style>
<template>
    <div class="container">
        
        <div class="toolbar">
            <el-button type="primary" size="small" icon="plus" @click="addHandle">新增</el-button>
            <el-button type="info" size="small" icon="edit" @click="handleEdit">修改</el-button>
            <el-button type="danger" size="small" icon="delete" @click="del">删除</el-button>
        </div>
    
        <div class="treeCtn">
            <Tree :message="DataList" @NodeClick="handleNodeClick" accordion="false" :defaultExpandedKeys="needExpendId"></Tree>
        </div>

        <!-- 添加 & 修改机构 -->
        <el-dialog :title="dialogTitle" v-model="dialogVisible" size="tiny">
            <el-form ref="form" label-width="80px">
                <el-form-item label="机构名称">
                    <el-input v-model="DepartmentName"></el-input>
                </el-form-item>
                <el-form-item label="上级机构">
                    <span>{{ActionParamentDialog.D_Name}}</span>
                    <el-button type="primary" @click="organizationVisible=true">选择机构</el-button>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="Actiondialog">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 添加 & 修改机构【end】 -->

        <!-- 选择上级机构 -->
        <el-dialog title="选择上级机构" v-model="organizationVisible" size="tiny">
            <Tree @NodeClick="handleActionClick" :message="DataList"></Tree>
            <span slot="footer" class="dialog-footer">
                <el-button @click="originDialog">取 消</el-button>
                <el-button type="primary" @click="organizationVisible = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 选择上级机构【end】 -->

        <!--<Employee v-model="a" @sure="getEmployeeData"></Employee>-->
    </div>
</template>

<script>
import organization from './organization.js';
module.exports=organization;
</script>


// WEBPACK FOOTER //
// organization.vue?11aafefe